export const ADD_MODULE_BUTTON_TEXT = 'Включить модуль в программу';
export const REMOVE_MODULE_BUTTON_TEXT = 'Исключить модуль из программы';



// WEBPACK FOOTER //
// ./src/components/parts/modules/modulebutton/consts.ts